import { gqlClient } from 'services/api/gql/gqlClient';
import { ProductRecommendations } from 'constants/gql/queries/productRecommendations/productRecommendations.gql';
import localeUtils from 'utils/LanguageLocale';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import userUtils from 'utils/User';

const PRODUCT_RECOMMENDATIONS_WITH_TAGS_QUERY = `query ProductRecommendations($request: ProductRecommendationInput!, $requestextra: ExplainabilityTagsInput!) {
  recommendations(request: $request) {
    resultId
    response {
      pod { id displayName }
      results {
        value
        strategy { id }
        product {
          productId brandName url imageUrl rating totalReviews
          explainabilityTags(request: $requestextra) { bucketId signalId tag }
          currentSku {
            colorName biExclusivityLevel isBI isNew skuId isBest isNatural isOrganic
            imageAltText isOnlineOnly isFirstAccess isAppExclusive isLimitedEdition
            isLimitedTimeOffer isSephoraExclusive variationValue
            skuImages { image135 image250 image450 }
            constructorSizeRefinement constructorValuePrice
          }
          variationId
          facets { name values }
        }
        variationsMap { minListPrice maxListPrice minSalePrice maxSalePrice }
      }
      totalNumResults
    }
  }
}`;

const getProductRecommendations = async (requestParams = {}) => {
    const { showMlTags, ...restParams } = requestParams;

    let client = 'ciojs-client-2.63.0';
    let s = null;
    let id = '';
    const locale = `${localeUtils.getCurrentLanguage().toLowerCase()}-${localeUtils.getCurrentCountry()}`;
    const profileId = Storage.local.getItem(LOCAL_STORAGE.USER_DATA)?.profile?.profileId || Storage.local.getItem(LOCAL_STORAGE.PROFILE_ID);

    if (window.ConstructorioClient) {
        const { queryParams } = window.ConstructorioTracker.options;
        client = queryParams.c;
        s = queryParams.s;
        id = queryParams.i;
    }

    const variables = {
        request: {
            client,
            s,
            id,
            ...(profileId && { ui: profileId }),
            locale,
            userSegments: 'external-app',
            variationsMap: {
                values: {
                    minListPrice: {
                        aggregation: 'min',
                        field: 'data.currentSku.listPriceFloat'
                    },
                    maxListPrice: {
                        aggregation: 'max',
                        field: 'data.currentSku.listPriceFloat'
                    },
                    minSalePrice: {
                        aggregation: 'min',
                        field: 'data.currentSku.salePriceFloat'
                    },
                    maxSalePrice: {
                        aggregation: 'max',
                        field: 'data.currentSku.salePriceFloat'
                    }
                },
                dtype: 'object'
            },
            ...restParams
        }
    };

    if (showMlTags) {
        const biAccountId = userUtils.getBiAccountId();
        const standardLocale = `${localeUtils.getCurrentLanguage().toUpperCase()}_${localeUtils.getCurrentCountry()}`;
        variables.requestextra = {
            clientId: biAccountId || '',
            locale: standardLocale,
            tagType: null,
            maxTags: 3
        };
    }

    const options = {
        operationName: 'ProductRecommendations',
        query: ProductRecommendations,
        variables,
        ...(showMlTags && { queryBody: PRODUCT_RECOMMENDATIONS_WITH_TAGS_QUERY, allowPartialResponse: true })
    };

    const response = await gqlClient.query(options);

    return response || null;
};

export default getProductRecommendations;
